import {LazyAsync, RestClient} from "zavadil-ts-common";
import {NodeWarningType, NodeWarningView} from "../../types/NodeWarning";
import {GenericResponsePayload} from "../../types/GenericResponsePayload";

export class CheckClient {

	client: RestClient;

	typesLazy: LazyAsync<Array<NodeWarningType>>;

	constructor(client: RestClient) {
		this.client = client;

		this.typesLazy = new LazyAsync(() => this.client.getJson('check/types'));
	}

	types(): Promise<Array<NodeWarningType>> {
		return this.typesLazy.get();
	}

	loadWarnings(typeId?: string): Promise<Array<NodeWarningView>> {
		return this.client.getJson('check/warnings', {typeId});
	}

	start(): Promise<GenericResponsePayload> {
		return this.client.getJson('check/start');
	}

	run(): Promise<GenericResponsePayload> {
		return this.client.getJson('check/run');
	}

	checkNode(nodeId: number): Promise<GenericResponsePayload> {
		return this.client.getJson('check/check-node', {nodeId});
	}

}
